const PH = ["5.0", "6.0", "6.5", "7.0", "7.5", "8.0", "8.5"];

export default PH;
